import styled from 'styled-components';

export const StyledFooter = styled.div`
    display: flex;
    color: white;
    justify-content: center;
    padding: 2rem 3rem;
    flex-direction: row;
    margin-top: auto;

    @media screen and (max-width: 768px) {
        display: block;
        width: 100%;
        margin: 0 auto;
    }

    @media screen and (max-width: 320px) {
        display: block;
        height: auto;
        width: 100%;
        margin: 0 auto;
        flex-direction: column;
    }
    @media screen and (min-width: 1366px) {
        max-width: 89rem;
        margin: auto;
    }
`;

export const FooterContainer = styled.div`
    background: #425364;
`;

export const FooterRow = styled.div`
    &:last-child {
        text-align: right;
        flex: 1;
    }

    @media screen and (max-width: 1024px) {
        &:first-child {
            flex: 1;
        }
    }

    @media screen and (max-width: 768px) {
        &:last-child {
            text-align: left;
        }
    }
`;

export const FooterColumn = styled.div`
    flex: 1;
    &:last-child {
        text-align: right;
    }

    @media screen and (max-width: 768px) {
        &:last-child {
            text-align: left;
        }
    }
`;

export const FooterSection = styled.div`
    font-size: 14px;
    @media screen and (max-width: 320px) {
        :nth-child(2) {
            padding-top: 1rem;
        }
    }
`;

export const FooterLinkText = styled.div`
    a {
        text-decoration: underlined;
        color: #fff;
        cursor: pointer;
        padding: 6px;
        font-family: Roboto, sans-serif;
        display: inline-block;

        @media screen and (max-width: 768px) {
            display: inline-block;
            :nth-child(1) {
                padding-left: 0;
            }
        }

        @media screen and (max-width: 760px) {
            padding: 6px 6px 6px 0;
            :nth-child(2) {
                padding-left: 6px;
            }
        }
    }
`;

export const FooterImg = styled.img`
    height: 46.75px;
    width: 44px;
    margin-left: 15px;
    vertical-align: bottom;

    @media screen and (max-width: 320px) {
        display: block;
        margin-left: 0;
        margin-top: 10px;
    }
`;

export const Separator = styled.span`
    &:last-child {
        display: none;
    }
`;
